import axios from 'axios';
import store from '../store';

// axios.interceptors.response.use(
//   function(response) { return response; },
//   function(error) {
//       if (error.response) {
//         console.log(error.response);
//         store.commit('showNotification', { text: error.response.data.error, status: 'error' });
//         return Promise.reject(error);
//       }
//   });

// const endpoint = 'http://nuvem.syclus.com.br:5000/api/syclus/sistema/sql/7';
// const baseUrl = 'http://192.168.1.8:3000';
const baseUrl = process.env.VUE_APP_ROOT_API;

const state = {
  tiposAtividade: [],
  tipoAtividadeWorkflows: []
};

const getters = {
  // Tipos Atividade
  tiposAtividade: state => state.tiposAtividade.sort((a,b) => a.Descricao > b.Descricao ? 1 : -1),
  tiposAtividadeAtivo: state => state.tiposAtividade.filter(t => t.Status.startsWith('A')).sort((a,b) => a.Descricao > b.Descricao ? 1 : -1),
  tipoAtividadeWorkflows: state => state.tipoAtividadeWorkflows.sort((a,b) => a.Workflow > b.Workflow ? 1 : -1),
}

const actions = {
  // Tipos Atividade
  async fetchTiposAtividade({ commit }) {
    try {
      const response = await axios.get(`${baseUrl}/tiposatividades`);
      if (response.data.length) {
        commit('setTiposAtividade', response.data);
      } 
    } catch (error) {
      commit('setTiposAtividade', []);
    }
  },
  async fetchTiposAtividadeSql({ commit }, args) {
    try {
      const response = await axios.get(`${baseUrl}/tiposatividades?idLayoutSql=${args.idLayoutSql}`);
      if (response.data.length) {
        commit('setTiposAtividade', response.data);
      } else {
        commit('setTiposAtividade', []);
      }
    } catch (error) {
      commit('setTiposAtividade', []);
    }
  },
  async addTipoAtividade({ commit }, tipoAtividade) {
    const response = await axios.post(`${baseUrl}/tiposatividades`, tipoAtividade);
    tipoAtividade.IdTipoAtividade = response.data.IdTipoAtividade;
    commit('newTipoAtividade', tipoAtividade);
    return response.data.IdTipoAtividade;
  },
  async updateTipoAtividade({ commit }, updTipoAtividade) {
    await axios.put(`${baseUrl}/tiposatividades`, updTipoAtividade);
    commit('updateTipoAtividade', updTipoAtividade);
  },
  async deleteTipoAtividade({ commit }, id) {
    await axios.delete(`${baseUrl}/tiposatividades/${id}`);
    commit('removeTipoAtividade', id);
  },
  // Workflows
  resetaTipoAtividadeWorkflows({ commit }) {
    commit('resetaTipoAtividadeWorkflows');
  },
  async fetchTipoAtividadeWorkflows({ commit }, id) {
    try {
      const response = await axios.get(`${baseUrl}/tiposatividades/${id}/workflows`);
      if (response.data.length) {
        commit('setTipoAtividadeWorkflows', response.data);
      } else {
        commit('setTipoAtividadeWorkflows', []);  
      }
    } catch (error) {
      commit('setTipoAtividadeWorkflows', []);
    }
  },
  async addTipoAtividadeWorkflow({ commit }, tipoAtividadeWorkflow) {
    try {
      const response = await axios.post(`${baseUrl}/tiposatividades/${tipoAtividadeWorkflow.IdTipoAtividade}/workflows`, tipoAtividadeWorkflow);
      if (response) {
        commit('newTipoAtividadeWorkflow', tipoAtividadeWorkflow);
      }
      return response;
    } catch (error) {
      console.log(error);
      return error;
    }
  },
  async deleteTipoAtividadeWorkflow({ commit }, tipoAtividadeWorkflow) {
    await axios.delete(`${baseUrl}/tiposatividades/${tipoAtividadeWorkflow.IdTipoAtividade}/workflows/${tipoAtividadeWorkflow.IdWorkflow}`);
    commit('removeTipoAtividadeWorkflow', tipoAtividadeWorkflow.IdWorkflow);
  },
}

const mutations = {
  // Tipos Atividade
  setTiposAtividade: (state, tiposAtividade) => state.tiposAtividade = tiposAtividade,
  newTipoAtividade: (state, tipoAtividade) => state.tiposAtividade.push(tipoAtividade),
  removeTipoAtividade: (state, id) => state.tiposAtividade = state.tiposAtividade.filter(tipoAtividade => tipoAtividade.IdTipoAtividade !== id),
  updateTipoAtividade: (state, updTipoAtividade) => {
    const index = state.tiposAtividade.findIndex(tipoAtividade => tipoAtividade.IdTipoAtividadae === updTipoAtividade.IdTipoAtividade);
    if (index !== -1) {
      state.tiposAtividade.splice(index, 1, updTipoAtividade);
    }
  },
  // Workflows
  resetaTipoAtividadeWorkflows: state => state.tipoAtividadeWorkflows = [],
  setTipoAtividadeWorkflows: (state, workflows) => state.tipoAtividadeWorkflows = workflows,
  newTipoAtividadeWorkflow: (state, workflow) => state.tipoAtividadeWorkflows.push(workflow),
  removeTipoAtividadeWorkflow: (state, id) => state.tipoAtividadeWorkflows = state.tipoAtividadeWorkflows.filter(workflow => workflow.IdWorkflow !== id),
}

export default {
  state,
  getters,
  actions,
  mutations
}